module.exports = __webpack_public_path__ + "static/media/54.9643dc77.jpg";